'use strict';

angular.module('ClinicApp').directive('profileFeatures', function() {
  return {
    scope: {
      allFeatures: '=',
      selectedFeatures: '=profileFeatures',
      isSafetyProcedures: '=', // TODO: there is should be another directive for this.
      editMode: '=',
      onSave: '&',
      onCancel: '&',
    },
    templateUrl: '/views/directives/_profile-features.html',
    link: function($scope) {
      $scope.features = [];

      function initialize() {
        $scope.features = _.chain($scope.allFeatures).clone()
          .forEach(function(feature) {
            feature.selected = !!_.find($scope.selectedFeatures, function(selectedFeature) {
              return selectedFeature.id === feature.id;
            });
          })
          .value();
      }

      $scope.$watch('selectedFeatures', initialize);

      $scope.save = function() {
        return $scope.onSave({
          features: _.filter($scope.features, function(feature) {
            return feature.selected;
          }),
        });
      };

      $scope.cancel = function() {
        initialize();
        return $scope.onCancel();
      };
    },
  };
});
